import {
  TOGGLE_FILTERS_PANEL,
  TOGGLE_SUBSCRIBE_POPUP,
  INIT_APP,
} from './constants';

export const toggleFiltersAction = (payload) => ({
  type: TOGGLE_FILTERS_PANEL,
  payload,
});

export const toggleSubscribeAction = () => ({
  type: TOGGLE_SUBSCRIBE_POPUP,
});

export const initAppAction = () => ({
  type: INIT_APP,
});
